import { DiaryHomework } from './types';

export const initialDiaryState: DiaryHomework = {
  subject: '',
  studentClass: '',
  section: '',
  homeworkDate: '',
  content: '',
  diaryContent: '',
  createdBy: '',
};
